import axios from "axios";
import router from "../router/index";
import { FormItem, Message } from "element-ui";
import { Store } from "vuex";
import { prototype } from "swiper";

const eventdashboard = {
  state: () => ({
    overview: {
      isActive: true,
      loading: false,
      data: null
    },

    content: {
      isActive: false,
      loading: false,
      data: null
    },

    certificate: {
      isActive: false,
      loading: false,
      data: null
    },

    automatedmessages: {
      isActive: false,
      loading: false,
      data: null
    },

    abstract: {
      isActive: false,
      loading: false,
      data: null
    },

    onsite: {
      isActive: false,
      loading: false,
      data: null
    },

    onsiteFilter: {
      forceRefresh: true,
      checkInTagId: null,
      automaticCheckInTagId: null,
      automaticCheckInType: null,
      accessLogTagId: null,
      accessLogType: null,
      cardPrintTagId: null,
      promotionReceiveTagId: null,
      standCheckInTagId: null,
      standCheckInType: null
    },

    live: {
      isActive: false,
      loading: false,
      data: null
    },

    registration: {
      isActive: false,
      loading: false,
      data: null
    },

    registrationForms: []
  }),
  mutations: {
    resetDashboardAllData(state) {
      state.overview = {
        isActive: true,
        loading: false,
        data: null
      };

      state.content = {
        isActive: false,
        loading: false,
        data: null
      };

      state.certificate = {
        isActive: false,
        loading: false,
        data: null
      };

      state.automatedmessages = {
        isActive: false,
        loading: false,
        data: null
      };

      state.abstract = {
        isActive: false,
        loading: false,
        data: null
      };

      state.onsite = {
        isActive: false,
        loading: false,
        data: null
      };

      state.onsiteFilter = {
        forceRefresh: true,
        checkInTagId: null,
        automaticCheckInTagId: null,
        automaticCheckInType: null,
        accessLogTagId: null,
        accessLogType: null,
        cardPrintTagId: null,
        promotionReceiveTagId: null,
        standCheckInTagId: null,
        standCheckInType: null
      };

      state.live = {
        isActive: false,
        loading: false,
        data: null
      };

      state.registration = {
        isActive: false,
        loading: false,
        data: null
      };
      state.registrationForms = [];
    },
    setOverviewData(state, payload) {
      state.overview.data = payload;
    },
    setContentData(state, payload) {
      state.content.data = payload;
    },
    setCertificateData(state, payload) {
      state.certificate.data = payload;
    },
    setAutomatedMessagesData(state, payload) {
      state.automatedmessages.data = payload;
    },
    setAbstractData(state, payload) {
      state.abstract.data = payload;
    },
    setOnsiteData(state, payload) {
      state.onsite.data = payload;
    },
    setOnsiteFilter(state, payload) {
      state.onsiteFilter = payload;
    },
    setLiveData(state, payload) {
      state.live.data = payload;
    },
    setRegistrationData(state, payload) {
      if (!state.registrationForms.find(x => x.registrationFormId == payload.registrationFormId)) {
        state.registrationForms.push(payload);
      } else {
        var index = state.registrationForms.findIndex(k => k.registrationFormId == payload.registrationFormId);
        state.registrationForms.splice(index, payload);
      }
    },
    setLoading(state, payload) {
      if (payload.data == "overview") state.overview.loading = payload.loading;
      if (payload.data == "content") state.content.loading = payload.loading;
      if (payload.data == "certificate") state.certificate.loading = payload.loading;
      if (payload.data == "automatedmessages") state.automatedmessages.loading = payload.loading;
      if (payload.data == "abstract") state.abstract.loading = payload.loading;
      if (payload.data == "onsite") state.onsite.loading = payload.loading;
      if (payload.data == "live") state.live.loading = payload.loading;
      if (payload.data == "registration") state.registration.loading = payload.loading;
    },
    setIsActive(state, payload) {
      if (payload.data == "overview") state.overview.isActive = payload.isActive;
      if (payload.data == "content") state.content.isActive = payload.isActive;
      if (payload.data == "certificate") state.certificate.isActive = payload.isActive;
      if (payload.data == "automatedmessages") state.automatedmessages.isActive = payload.isActive;
      if (payload.data == "abstract") state.abstract.isActive = payload.isActive;
      if (payload.data == "onsite") state.onsite.isActive = payload.isActive;
      if (payload.data == "live") state.live.isActive = payload.isActive;
      if (payload.data == "registration") state.registration.isActive = payload.isActive;
    }
  },
  actions: {
    async setLoading(store, payload) {
      store.commit("setLoading", payload);
    },
    async setIsActive(store, payload) {
      store.commit("setIsActive", payload);
    },
    async getOverview(store, payload) {
      store.commit("setLoading", { data: "overview", loading: true });
      var res = await axios.post("statistics/generalstatistics", payload);
      if (!res.data.alert.hasError) {
        var chartData = {
          datasets: []
        };

        res.data.data.segmentations.map(x =>
          chartData.datasets.push({
            key: x.title,
            value: x.participantCount,
            color: x.color
          })
        );

        res.data.data.chartData = chartData;
        store.commit("setOverviewData", res.data.data);
      } else {
        Message.error(res.data.alert.message);
      }
      store.commit("setLoading", { data: "overview", loading: false });
    },
    async getContent(store, payload) {
      store.commit("setLoading", { data: "content", loading: true });
      var res = await axios.post("statistics/contentstatistics", payload);
      if (!res.data.alert.hasError) {
        store.commit("setContentData", res.data.data);
      } else {
        Message.error(res.data.alert.message);
      }
      store.commit("setLoading", { data: "content", loading: false });
    },
    async getCertificate(store, payload) {
      store.commit("setLoading", { data: "certificate", loading: true });
      var res = await axios.post("statistics/certificatestatistics", payload);
      if (!res.data.alert.hasError) {
        store.commit("setCertificateData", res.data.data);
      } else {
        Message.error(res.data.alert.message);
      }
      store.commit("setLoading", { data: "certificate", loading: false });
    },
    async getAutomatedMessages(store, payload) {
      store.commit("setLoading", { data: "automatedmessages", loading: true });
      var res = await axios.post("statistics/automatedmessagestatistics", payload);
      if (!res.data.alert.hasError) {
        store.commit("setAutomatedMessagesData", res.data.data);

        var chartDataEmailVouchers = {
          datasets: []
        };

        chartDataEmailVouchers.datasets.push({
          key: "Kuyrukta",
          value: res.data.data.emailVoucherStatus == null || res.data.data.emailVoucherStatus.queue == null ? 0 : res.data.data.emailVoucherStatus.queue,
          color: "#FFD100"
        });

        chartDataEmailVouchers.datasets.push({
          key: "Gönderildi",
          value: res.data.data.emailVoucherStatus == null || res.data.data.emailVoucherStatus.sent == null ? 0 : res.data.data.emailVoucherStatus.sent,
          color: "#6457F9"
        });

        chartDataEmailVouchers.datasets.push({
          key: "İletildi",
          value: res.data.data.emailVoucherStatus == null || res.data.data.emailVoucherStatus.delivered == null ? 0 : res.data.data.emailVoucherStatus.delivered,
          color: "#ACE60F"
        });

        chartDataEmailVouchers.datasets.push({
          key: "Okundu",
          value: res.data.data.emailVoucherStatus == null || res.data.data.emailVoucherStatus.read == null ? 0 : res.data.data.emailVoucherStatus.read,
          color: "#50BFBF"
        });

        chartDataEmailVouchers.datasets.push({
          key: "Hata Oluştu",
          value: res.data.data.emailVoucherStatus == null || res.data.data.emailVoucherStatus.error == null ? 0 : res.data.data.emailVoucherStatus.error,
          color: "#FF6565"
        });

        res.data.data.chartDataEmailVouchers = chartDataEmailVouchers;

        var chartDataSmsVouchers = {
          datasets: []
        };

        chartDataSmsVouchers.datasets.push({
          key: "Kuyrukta",
          value: res.data.data.smsVoucherStatus == null || res.data.data.smsVoucherStatus.queue == null ? 0 : res.data.data.smsVoucherStatus.queue,
          color: "#FFD100"
        });

        chartDataSmsVouchers.datasets.push({
          key: "Gönderildi",
          value: res.data.data.smsVoucherStatus == null || res.data.data.smsVoucherStatus.sent == null ? 0 : res.data.data.smsVoucherStatus.sent,
          color: "#6457F9"
        });

        chartDataSmsVouchers.datasets.push({
          key: "İletildi",
          value: res.data.data.smsVoucherStatus == null || res.data.data.smsVoucherStatus.delivered == null ? 0 : res.data.data.smsVoucherStatus.delivered,
          color: "#ACE60F"
        });

        chartDataSmsVouchers.datasets.push({
          key: "Okundu",
          value: res.data.data.smsVoucherStatus == null || res.data.data.smsVoucherStatus.read == null ? 0 : res.data.data.smsVoucherStatus.read,
          color: "#50BFBF"
        });

        chartDataSmsVouchers.datasets.push({
          key: "Hata Oluştu",
          value: res.data.data.smsVoucherStatus == null || res.data.data.smsVoucherStatus.error == null ? 0 : res.data.data.smsVoucherStatus.error,
          color: "#FF6565"
        });

        res.data.data.chartDataSmsVouchers = chartDataSmsVouchers;

        var chartDataAutomatedMessages = {
          datasets: []
        };

        chartDataAutomatedMessages.datasets.push({
          key: "Kuyrukta",
          value: res.data.data.automatedEmailsStatus == null || res.data.data.automatedEmailsStatus.queue == null ? 0 : res.data.data.automatedEmailsStatus.queue,
          color: "#FFD100"
        });

        chartDataAutomatedMessages.datasets.push({
          key: "Gönderildi",
          value: res.data.data.automatedEmailsStatus == null || res.data.data.automatedEmailsStatus.sent == null ? 0 : res.data.data.automatedEmailsStatus.sent,
          color: "#6457F9"
        });

        chartDataAutomatedMessages.datasets.push({
          key: "İletildi",
          value: res.data.data.automatedEmailsStatus == null || res.data.data.automatedEmailsStatus.delivered == null ? 0 : res.data.data.automatedEmailsStatus.delivered,
          color: "#ACE60F"
        });

        chartDataAutomatedMessages.datasets.push({
          key: "Okundu",
          value: res.data.data.automatedEmailsStatus == null || res.data.data.automatedEmailsStatus.read == null ? 0 : res.data.data.automatedEmailsStatus.read,
          color: "#50BFBF"
        });

        chartDataAutomatedMessages.datasets.push({
          key: "Hata Oluştu",
          value: res.data.data.automatedEmailsStatus == null || res.data.data.automatedEmailsStatus.error == null ? 0 : res.data.data.automatedEmailsStatus.error,
          color: "#FF6565"
        });

        res.data.data.chartDataAutomatedMessages = chartDataAutomatedMessages;

        var chartDataInformationEmails = {
          datasets: []
        };

        chartDataInformationEmails.datasets.push({
          key: "Kuyrukta",
          value: res.data.data.informationEmailsStatus == null || res.data.data.informationEmailsStatus.queue == null ? 0 : res.data.data.informationEmailsStatus.queue,
          color: "#FFD100"
        });

        chartDataInformationEmails.datasets.push({
          key: "Gönderildi",
          value: res.data.data.informationEmailsStatus == null || res.data.data.informationEmailsStatus.sent == null ? 0 : res.data.data.informationEmailsStatus.sent,
          color: "#6457F9"
        });

        chartDataInformationEmails.datasets.push({
          key: "İletildi",
          value: res.data.data.informationEmailsStatus == null || res.data.data.informationEmailsStatus.delivered == null ? 0 : res.data.data.informationEmailsStatus.delivered,
          color: "#ACE60F"
        });

        chartDataInformationEmails.datasets.push({
          key: "Okundu",
          value: res.data.data.informationEmailsStatus == null || res.data.data.informationEmailsStatus.read == null ? 0 : res.data.data.informationEmailsStatus.read,
          color: "#50BFBF"
        });

        chartDataInformationEmails.datasets.push({
          key: "Hata Oluştu",
          value: res.data.data.informationEmailsStatus == null || res.data.data.informationEmailsStatus.error == null ? 0 : res.data.data.informationEmailsStatus.error,
          color: "#FF6565"
        });

        res.data.data.chartDataInformationEmails = chartDataInformationEmails;
      } else {
        Message.error(res.data.alert.message);
      }
      store.commit("setLoading", { data: "automatedmessages", loading: false });
    },
    async getAbstract(store, payload) {
      store.commit("setLoading", { data: "abstract", loading: true });
      var res = await axios.post("statistics/abstractstatistics", payload);
      if (!res.data.alert.hasError) {
        var chartData = {
          datasets: []
        };

        chartData.datasets.push({
          key: "Accepted",
          value: res.data.data.abstractStatistics.filter(x => x.accepted > 0).reduce((partialSum, a) => partialSum + a, 0),
          color: "#ACE60F"
        });

        chartData.datasets.push({
          key: "Conditionally Accepted",
          value: res.data.data.abstractStatistics.filter(x => x.conditionallyAccepted > 0).reduce((partialSum, a) => partialSum + a, 0),
          color: "#FFD100"
        });

        chartData.datasets.push({
          key: "Rejected",
          value: res.data.data.abstractStatistics.filter(x => x.rejected > 0).reduce((partialSum, a) => partialSum + a, 0),
          color: "#FF6565"
        });

        chartData.datasets.push({
          key: "Waiting",
          value: res.data.data.abstractStatistics.filter(x => x.pending > 0).reduce((partialSum, a) => partialSum + a, 0),
          color: "#6457F9"
        });

        res.data.data.chartData = chartData;

        store.commit("setAbstractData", res.data.data);
      } else {
        Message.error(res.data.alert.message);
      }
      store.commit("setLoading", { data: "abstract", loading: false });
    },
    async getOnsite(store, payload) {
      if (payload.forceRefresh == true) {
        store.state.onsiteFilter = {
          forceRefresh: true,
          checkInTagId: null,
          automaticCheckInTagId: null,
          automaticCheckInType: null,
          accessLogTagId: null,
          accessLogType: null,
          cardPrintTagId: null,
          promotionReceiveTagId: null,
          standCheckInTagId: null,
          standCheckInType: null
        };
      }
      store.commit("setLoading", { data: "onsite", loading: true });
      var res = await axios.post("statistics/onsitestatistics", payload);
      if (!res.data.alert.hasError) {
        store.commit("setOnsiteData", res.data.data);
      } else {
        Message.error(res.data.alert.message);
      }
      store.commit("setLoading", { data: "onsite", loading: false });
    },
    async getLive(store, payload) {
      store.commit("setLoading", { data: "live", loading: true });
      var res = await axios.post("statistics/liveeventstatistics", payload);
      if (!res.data.alert.hasError) {
        store.commit("setLiveData", res.data.data);
      } else {
        Message.error(res.data.alert.message);
      }
      store.commit("setLoading", { data: "live", loading: false });
    },
    async getRegistration(store, payload) {
      store.commit("setLoading", { data: "registration", loading: payload.registrationFormId });
      var res = await axios.post("statistics/registrationformstatistics", payload);
      if (!res.data.alert.hasError) {
        var paymentAnalysticsChartData = {
          datasets: []
        };

        res.data.data.paymentAnalystics.map(x =>
          paymentAnalysticsChartData.datasets.push({
            key: x.title,
            value: x.count,
            color: x.color
          })
        );

        res.data.data.paymentAnalysticsChartData = paymentAnalysticsChartData;

        var packetStatisticsChartData = {
          datasets: []
        };

        res.data.data.packetStatistics.map(x =>
          packetStatisticsChartData.datasets.push({
            key: x.title,
            value: x.usage,
            color: x.color
          })
        );

        res.data.data.packetStatisticsChartData = packetStatisticsChartData;

        store.commit("setRegistrationData", res.data.data);
      } else {
        Message.error(res.data.alert.message);
      }
      store.commit("setLoading", { data: "registration", loading: false });
    },
    async exportXlscx(store, payload) {
      var res = await axios.post("Statistics/ExportXlsx", payload);
      if (res.data.alert.hasError) {
        Message.error(res.data.alert.message);
      } else {
        Message.success(res.data.alert.message);
      }
      return res;
    },
    async importXlscx(store, payload) {
      var res = await axios.post("Statistics/ImportXlsx", payload);
      if (res.data.alert.hasError) {
        Message.error(res.data.alert.message);
      } else {
        Message.success(res.data.alert.message);
      }
      return res;
    }
  },
  getters: {
    getDashboardOverview: state => state.overview,
    getDashboardContent: state => state.content,
    getDashboardCertificate: state => state.certificate,
    getDashboardAutomatedMessages: state => state.automatedmessages,
    getDashboardAbstract: state => state.abstract,
    getDashboardOnsite: state => state.onsite,
    getOnsiteFilter: state => state.onsiteFilter,
    getDashboardLive: state => state.live,
    getDashboardRegistration: state => state.registration,
    getDashboardRegistrationForms: state => state.registrationForms
  }
};
export default eventdashboard;



// WEBPACK FOOTER //
// ./src/store/eventdashboard.js